import DeviceDetector from './deviceDetector.js';

export default class DropdownManager {

    constructor() {
        this.deviceDetector = new DeviceDetector();
        this.activeDropdowns = [];
        this.eventDelegation();
    }

    eventDelegation() {
        // Click outside dropdown
        document.body.addEventListener('click', (event) => {
            const isCurrentDropdown = event.target.closest('[data-vpt-dropdown]');
            const isContainerClicked = event.target.dataset.container === 'dropdown-content';
            const isBottomsheetDropdown = event.target.closest('[data-mobile-type="bottomsheet"]');
            const backdrop = event.target.closest('[data-container-backdrop]');
            if (!isCurrentDropdown) {
                this.closeActiveDropdowns();
            } else if (isContainerClicked && isBottomsheetDropdown) {
                this.closeActiveDropdowns();
            } else if (backdrop) {
                this.closeActiveDropdowns();
            }
        });

        const dropdowns = document.querySelectorAll( '[data-vpt-dropdown]');
        dropdowns.forEach((dropdown) => {
            const dropdownButton = dropdown.querySelector('[data-container="dropdown-button"]');
            const dropdownCloseButtons = dropdown.querySelectorAll('[data-container="dropdown-close-button"], [data-container="dropdown-back-button"]');

            // Click on dropdown button
            dropdownButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.closeActiveDropdowns([dropdownButton]);
                this.toggleDropdown(dropdown);
            });

            // Click browser back button
            dropdown.addEventListener('pop-state', (event) => {
                if (this.isDropdownOpen(dropdown)) {
                    this.toggleDropdown(dropdown, false);
                }
            });

            if (dropdownCloseButtons.length) {
                // Click on dropdown header close button
                dropdownCloseButtons.forEach((dropdownCloseButton) => {
                    dropdownCloseButton.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.toggleDropdown(dropdown, false);
                    });
                })
            }

        });
        const hideOnScrollDropdowns = document.querySelectorAll('[data-hide-on-scroll="true"]');
            document.addEventListener("scroll", (event)=>{
                hideOnScrollDropdowns.forEach((dropdown) => {
                    this.toggleDropdown(dropdown, false);
                })
            });

    }

    isDropdownOpen(element) {
        return !element.querySelector('[data-container="dropdown-content"]').classList.contains('hidden');
    }

    getDropdownId(element) {
        if (!element.id) throw new Error('Dropdown element must have an id.');
        return element.id;
    }

    toggleDropdown(element, open) {
        const backdrop = document.querySelector('[data-backdrop="true"]')
        const isContainerOpen = this.isDropdownOpen(element);
        if (open === undefined) open = !isContainerOpen;
        if (open === isContainerOpen) return;

        this.animateDropdownToggle(element, open);

        const isMobile = ['xs', 'sm'].includes(this.deviceDetector.getDeviceSize(true));
        const dropdownQuerySelector = '#' + this.getDropdownId(element);
        if (open) {
            if (backdrop){
                document.querySelector('body').classList.add("open-backdrop");
            }
            this.activeDropdowns.push(element);
            if (isMobile) {
                document.body.classList.add('modal-open');
                myApp.browserHistoryManager.addState(dropdownQuerySelector);
            }
        } else {
            if (backdrop) {
                document.querySelector('body').classList.remove("open-backdrop");
            }
            this.activeDropdowns = this.activeDropdowns.filter((dropdown) => dropdown !== element);
            document.body.classList.remove('modal-open');
            if (isMobile && myApp.browserHistoryManager.checkStateExists(dropdownQuerySelector)) {
                myApp.browserHistoryManager.removeState(dropdownQuerySelector);
            }
        }
    }

    animateDropdownToggle(element, open) {
        if (open === undefined) return;
        const contentContainer = element.querySelector('[data-container="dropdown-content"]');
        if (open) {
            contentContainer.classList.remove('hidden');
            contentContainer.dispatchEvent(new Event('dropdown-show'));
        }

        const isAlignedCenter = element.dataset.align === 'center';
        const isMobile = ['xs', 'sm'].includes(this.deviceDetector.getDeviceSize(true));
        const mobileType = element.dataset.mobileType;
        const hiddenDropdownXPosition = isMobile && mobileType === 'bottomsheet' ? '30px' : '-30px';
        const currentTransform = isAlignedCenter && !isMobile ? 'translateX(-50%)' : 'translateX(0)';
        const keyframes = [
            {opacity: 0, transform: `translateY(${hiddenDropdownXPosition}) ${currentTransform}` },
            {opacity: 1, transform: `translateY(0) ${currentTransform}` }
        ];
        contentContainer.animate(open ? keyframes : keyframes.reverse(), {
            duration: 250,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }).finished.then(() => {
            if (!open) {
                contentContainer.classList.add('hidden');
                contentContainer.dispatchEvent(new Event('dropdown-hidden'));
            }
        });
    }

    closeActiveDropdowns(exceptions = []) {
        if (this.activeDropdowns.length === 0) return;
        this.activeDropdowns.forEach((dropdown) => {
            if (!exceptions.includes(dropdown)) {
                this.toggleDropdown(dropdown, false);
            }
        });
    }

}